/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { FooterOrigination, HeaderOrigination, ButtonAction } from '@honeycomb-npm/honeycomb-react';
import Info from '../components/Info';
import { Icon } from '@honeycomb-npm/honeycomb-react';
import { ERROR } from '../constants/errorConstants';
import axiosClient from '../axios/axiosClient';
import moment from 'moment';
import { HowToTrackPaymentUrl, PaymentTrackerDetailsViewUrl, PaymentTrackerUrl } from '../constants/urls';
import '@honeycomb-npm/honeycomb/src/foundations/icons/icons-inline.scss';
import './PaymentTracker.scss';
import { toLower } from 'lodash';

function PaymentTrackerDetailsView(props) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getPaymentTrackerDetailsViewUrl = PaymentTrackerDetailsViewUrl.replace(
            'transactionreference',
            toLower(props.paymentTrackingNumber),
        );
        const fetchData = async () => {
            try {
                const response = await axiosClient.get(getPaymentTrackerDetailsViewUrl);
                if (response && response.status === 200) {
                    const payload = response.data?.data ?? response.data;
                    if (payload) {
                        setData(payload);
                    } else {
                        setError(ERROR);
                    }
                } else if (response && response.data) {
                    const apiError = response.data.error ?? response.data;
                    setError(apiError?.message ? apiError : ERROR);
                } else {
                    setError(ERROR);
                }
            } catch (err) {
                setError(ERROR);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [props.paymentTrackingNumber]);

    const statusToIcon = (status) => {
        switch (status) {
            case 'In progress':
                return 'badgeInfo16';
            case 'Payee credited':
                return 'badgeSuccess16';
            case 'Refunding':
                return 'badgeAlert16';
            case 'Tracking details unavailable':
                return 'badgeCancelled16'
            default:
                return 'badgeCancelled16'
        }
    }

    return (
        <div className="app h100vh honeycomb textstyles--commbank" id="StartMainContent">
            <HeaderOrigination href="https://www.commbank.com.au/" />
            {/* for View */}
            {loading ? (
                <div className="centerBox">
                    <div className="spinner spinner--visible" role="alert" aria-live="polite">
                        <div className="spinner__indicator" aria-hidden="true"></div>
                        <span className="sr-only" tabIndex="-1">
                            Loading. Please wait.
                        </span>
                    </div>
                </div>
            ) : (
                <div className="d-flex flex-column flex-grow-1 px-0 ">
                    <div className="flex-grow-1 honeycomb textstyles--netbank">
                        <div className="scrollable-form container customer-onboarding-typeform container-padding">
                            <div className="col-lg-6 col-md-8 col-xs-12 px-3">
                                {data !== null && error === null && (
                                    <>
                                        <span className="icon-wrapper ">
                                            <i className="hc-icon hc-icon--control-page-up" aria-hidden="true" />{' '}
                                            <a href={PaymentTrackerUrl} className="hyperlink-standalone ml-1">
                                                {' '}
                                                Back
                                            </a>{' '}
                                        </span>
                                        <div className="row ">
                                            <div className="col-12 mt-2">
                                                    <>
                                                        <h1 className="margin-bottom-mb">Payment status</h1>
                                                    </>
                                            </div>
                                            <div className="col-12 mb-1">
                                                <div className="form-group mb-1">
                                                    <div className="mb-1">
                                                        <div className="col-12 mx-0 mr-2 mb-3 px-1 Text16EmphasisLeft">
                                                            <span className="mr-1">Status:</span>
                                                            <Icon symbol={statusToIcon(data?.status)} isInline>
                                                                {data?.status == 'Tracking details unavailable' ? (
                                                                    <span className="mx-0 Text16Left">Tracking details not available</span>
                                                                ) : (
                                                                    <span className="mx-0 Text16Left">{data?.status}</span>
                                                                )}
                                                            </Icon>
                                                        </div>
                                                        <div className="mb-2 w-100 d-flex margin-top-mt">
                                                            <div className="mx-0">
                                                                {data?.status !== 'Payee credited' && (
                                                                    <div>
                                                                        <p className="mb-0 Text16Left commbankBlack description">
                                                                            {data?.description}
                                                                        </p>
                                                                        {data?.status === 'Tracking details unavailable' && (
                                                                            <Icon symbol="controlLinkOut24" isRHS>
                                                                                <a href={HowToTrackPaymentUrl}
                                                                                   target="_blank"
                                                                                   rel="noopener noreferrer">
                                                                                    How to track your payment
                                                                                </a>
                                                                            </Icon>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {data?.status !== 'Payee credited' && (
                                                            <div>
                                                                <Info />
                                                            </div>
                                                        )}
                                                        <div className="mb-2">
                                                            <div className="col-12 mx-0 px-0 Text16EmphasisLeft">
                                                                Payment tracking reference
                                                            </div>
                                                            <p className="mb-1">{data?.transactionReference}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mb-2">
                                                        <div className="col-12 mx-0 px-0 Text16EmphasisLeft">
                                                            {data?.status !== 'Payee credited' ? 'Payment made' : 'Initiation time'}
                                                        </div>
                                                        <p className="mb-1">
                                                            {moment(data?.initiationTime, moment.ISO_8601).format('DD MMM YYYY HH:mm ')}{' '}
                                                            (Syd/Melb time)
                                                        </p>
                                                    </div>
                                                    <div className="mb-2">
                                                        <div className="col-12 mx-0 px-0 Text16EmphasisLeft">
                                                            {data?.status !== 'Payee credited' ? 'Status updated' : 'Last updated'}
                                                        </div>
                                                        <p className="mb-bottom">
                                                            {moment(data?.lastUpdatedTime, moment.ISO_8601).format('DD MMM YYYY HH:mm ')}{' '}
                                                            (Syd/Melb time)
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {error !== null && data === null && (
                                    <div className="m-xl-8 m-md-8">
                                        <Icon
                                            id="ErrorMessage"
                                            symbol="messageAlert32"
                                            className="icon_content"
                                            iconClassName="icon_class"
                                        ></Icon>

                                        <h4 className="mb-0 mt-2">{error.message}</h4>
                                        <h6 className="Text14Left mb-0 mt-1">Try again later.</h6>
                                        <a href={PaymentTrackerUrl} data-testid="link">
                                            <ButtonAction type="button" className="mt-2">
                                                OK
                                            </ButtonAction>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {data?.status != 'Recipient credited' ? <FooterOrigination /> : <></>}
                </div>
            )}
        </div>
    );
}
export default PaymentTrackerDetailsView;